import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';
import { FiltersFormCirculationArea, FitersCadastralVM } from './list/types';

export const initialValuesCirculationAreas: FiltersFormCirculationArea & FitersCadastralVM = {
  name: '',
  code: '',
  number: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
  sheet: '',
  isCadastral: false,
  particle: '',
  subordinate: '',
};

const PageCirculationAreasInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesCirculationAreas}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageCirculationAreasInitializer.displayName = 'Page circulation areas initializer component';

export default PageCirculationAreasInitializer;
